import { useState } from 'react';

// SVG icons per design system spec
const BadgeIcon = ({ slug, size = 22 }) => {
  const s = size;
  const props = { width: s, height: s, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' };

  switch (slug) {
    case 'seed': // semente/broto — 2 folhas
      return (
        <svg {...props}>
          <path d="M12 22V12" />
          <path d="M12 12C12 12 8 10 8 6a4 4 0 0 1 8 0c0 4-4 6-4 6z" />
          <path d="M12 15c0 0-3 1-4 4" />
        </svg>
      );
    case 'feather': // pena/escrita
      return (
        <svg {...props}>
          <path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z" />
          <line x1="16" y1="8" x2="2" y2="22" />
          <line x1="17.5" y1="15" x2="9" y2="15" />
        </svg>
      );
    case 'calendar-check': // calendário com check
      return (
        <svg {...props}>
          <rect x="3" y="4" width="18" height="18" rx="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
          <polyline points="9 16 11 18 15 14" />
        </svg>
      );
    case 'flame': // chama simples
      return (
        <svg {...props}>
          <path d="M12 2c0 0-4 4-4 8.5a4 4 0 0 0 8 0C16 6 12 2 12 2z" />
          <path d="M12 12c0 0-2 1.5-2 3.5a2 2 0 0 0 4 0C14 13.5 12 12 12 12z" />
        </svg>
      );
    case 'trophy': // troféu outline
      return (
        <svg {...props}>
          <polyline points="6 9 6 2 18 2 18 9" />
          <path d="M6 9a6 6 0 0 0 12 0" />
          <line x1="12" y1="15" x2="12" y2="19" />
          <line x1="8" y1="19" x2="16" y2="19" />
          <rect x="5" y="2" width="2" height="7" rx="1" fill="currentColor" stroke="none" opacity="0" />
        </svg>
      );
    case 'book': // livro aberto
      return (
        <svg {...props}>
          <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
          <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
        </svg>
      );
    case 'diploma': // chapéu de formatura
      return (
        <svg {...props}>
          <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
          <path d="M6 12v5c3 3 9 3 12 0v-5" />
        </svg>
      );
    case 'book-open': // livro aberto com páginas
      return (
        <svg {...props}>
          <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
          <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
          <line x1="12" y1="7" x2="12" y2="21" />
        </svg>
      );
    case 'bookmark': // marcador de página
      return (
        <svg {...props}>
          <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
        </svg>
      );
    case 'bookstack': // pilha de livros
      return (
        <svg {...props}>
          <rect x="3" y="15" width="18" height="4" rx="1" />
          <rect x="5" y="10" width="14" height="4" rx="1" />
          <rect x="7" y="5" width="10" height="4" rx="1" />
        </svg>
      );
    case 'bookstar': // livro com estrela
      return (
        <svg {...props}>
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
          <polygon points="12 7 13 9.5 15.5 9.5 13.5 11 14.5 13.5 12 12 9.5 13.5 10.5 11 8.5 9.5 11 9.5 12 7" fill="currentColor" stroke="none" />
        </svg>
      );
    case 'challenge-star': // troféu/estrela — desafio concluído
      return (
        <svg {...props}>
          <path d="M6 9H4a2 2 0 0 1-2-2V5h4" />
          <path d="M18 9h2a2 2 0 0 0 2-2V5h-4" />
          <path d="M12 17v4" />
          <path d="M8 21h8" />
          <path d="M6 5h12v6a6 6 0 0 1-6 6 6 6 0 0 1-6-6V5z" />
        </svg>
      );
    case 'challenge-flame': // força — 3 desafios
      return (
        <svg {...props}>
          <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />
        </svg>
      );
    case 'challenge-heart': // coração grato
      return (
        <svg {...props}>
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
        </svg>
      );
    case 'share': // 1ª reflexão compartilhada
      return (
        <svg {...props}>
          <circle cx="18" cy="5" r="3" />
          <circle cx="6" cy="12" r="3" />
          <circle cx="18" cy="19" r="3" />
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
          <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
        </svg>
      );
    case 'share-10': // 10 reflexões compartilhadas
      return (
        <svg {...props}>
          <circle cx="18" cy="5" r="3" />
          <circle cx="6" cy="12" r="3" />
          <circle cx="18" cy="19" r="3" />
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
          <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
          <circle cx="6" cy="12" r="1.5" fill="currentColor" stroke="none" />
        </svg>
      );
    default:
      return (
        <svg {...props}>
          <circle cx="12" cy="12" r="9" />
        </svg>
      );
  }
};

export default function BadgeShelf({ badges }) {
  const [selectedSlug, setSelectedSlug] = useState(null);
  const earned = badges.filter(b => b.earned).length;
  const selectedBadge = badges.find(b => b.slug === selectedSlug);

  const handleClick = (slug) => {
    setSelectedSlug(prev => prev === slug ? null : slug);
  };

  return (
    <div className="card">
      <p className="card-title">
        Conquistas
        <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, fontWeight: 300, color: 'var(--muted)', marginLeft: 8 }}>
          {earned}/{badges.length}
        </span>
      </p>
      <div className="badge-grid">
        {badges.map(badge => (
          <div
            key={badge.slug}
            className={`badge-item ${badge.earned ? '' : 'locked'}`}
            onClick={() => handleClick(badge.slug)}
            style={{ cursor: 'pointer' }}
          >
            <div className="badge-icon-wrap">
              <BadgeIcon slug={badge.iconSlug} />
            </div>
            <span className="badge-name">{badge.name}</span>
          </div>
        ))}
      </div>

      {selectedBadge && (
        <div style={{
          marginTop: 16,
          padding: '12px 14px',
          background: 'var(--offwhite, #f4f2ee)',
          borderRadius: 12,
          display: 'flex',
          alignItems: 'flex-start',
          gap: 10,
        }}>
          <div style={{ flexShrink: 0, marginTop: 1, color: selectedBadge.earned ? 'var(--teal)' : 'var(--muted)' }}>
            <BadgeIcon slug={selectedBadge.iconSlug} size={18} />
          </div>
          <div>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, fontWeight: 600, color: 'var(--navy)', marginBottom: 2 }}>
              {selectedBadge.name}
            </p>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: 'var(--muted)', lineHeight: 1.5 }}>
              {selectedBadge.earned
                ? selectedBadge.description
                : `Como ganhar: ${selectedBadge.howToEarn}`}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
